var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "jumbo-hero",
    style: _vm.style
  }, [_c('Container', [_c('div', {
    staticClass: "jumbo-hero__title"
  }, [_c('span', {
    staticClass: "jumbo-hero__one"
  }, [_vm._v("Debit")]), _vm._v(" "), _c('span', {
    staticClass: "jumbo-hero__two"
  }, [_vm._v("that")]), _vm._v(" "), _c('span', {
    staticClass: "jumbo-hero__three"
  }, [_vm._v("builds")]), _vm._v(" "), _c('span', {
    staticClass: "jumbo-hero__four"
  }, [_vm._v("credit")])]), _vm._v(" "), _c('div', {
    staticClass: "jumbo-hero__info"
  }, [_c('ul', [_c('li', [_vm._v("No interest or hidden fees—ever")]), _vm._v(" "), _c('li', [_vm._v("Earn rewards with every swipe"), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('li', [_vm._v("Use your own bank account"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('a', {
    staticClass: "jumbo-hero__cta",
    attrs: {
      "href": _vm.existingParams ? `/application?${_vm.existingParams}` : '/application'
    }
  }, [_vm._v("Start Building Credit")])])]), _vm._v(" "), _vm.showBgImg ? _c('background-image', {
    attrs: {
      "image": _vm.bgImg
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };